import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-views-box',
  templateUrl: './views-box.component.html',
  styleUrls: ['./views-box.component.scss']
})
export class ViewsBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
